import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isActive"];
// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-navigation-template-activatable/src/index.tsx
import React from 'react';
import baseIcon, { navigationActivatableDefaultStyleSheetGetter, defaultNavigationIconGroupProps, defaultNavigationIconShapeSize } from '@bubble-ui/temp-icon-base';
import useDeprecationWarning from '@bubble-ui/hook-use-deprecation-warning';
var NavigationIconInspirationPath = 'M17,3.5 C18.3491527,3.5 19.4902976,4.39058787 19.8676193,5.61594852 L24.2043619,6.25047505 C24.9922556,6.36542095 25.7021348,6.78887012 26.1776216,7.42754166 C26.6098822,8.00815215 26.8161917,8.72332997 26.763284,9.43918928 L26.7396019,9.65383363 L24.569525,24.5843619 C24.454579,25.3722556 24.0311299,26.0821348 23.3924583,26.5576216 C22.8118479,26.9898822 22.09667,27.1961917 21.3801967,27.1431945 L21.1653492,27.1194828 L10.09,25.5 L7,25.5 C5.40231912,25.5 4.09633912,24.25108 4.00509269,22.6762728 L4,22.5 L4,6.5 C4,4.84314575 5.34314575,3.5 7,3.5 L7,3.5 Z M20,7.656 L20,22.5 C20,23.4103231 19.5945422,24.2259464 18.954366,24.7761306 L21.455475,25.1406381 C21.718063,25.1792488 21.985229,25.1118869 22.1981195,24.9533913 C22.3755283,24.8213116 22.503117,24.6349745 22.5628473,24.424851 L22.5903981,24.2961664 L24.7606381,9.36452495 C24.7992488,9.10193701 24.7318869,8.834771 24.5733913,8.62188049 C24.4413116,8.44447173 24.2549745,8.31688296 24.0443463,8.25707912 L23.9152942,8.22947473 L20,7.656 Z M17,5.5 L7,5.5 C6.44771525,5.5 6,5.94771525 6,6.5 L6,6.5 L6,22.5 C6,23.0522847 6.44771525,23.5 7,23.5 L7,23.5 L17,23.5 C17.5522847,23.5 18,23.0522847 18,22.5 L18,22.5 L18,6.5 C18,5.94771525 17.5522847,5.5 17,5.5 L17,5.5 Z M16 18.5L16 20.5 8 20.5 8 18.5zM12 8.5C9.790861 8.5 8 10.290861 8 12.5 8 14.709139 9.790861 16.5 12 16.5 14.209139 16.5 16 14.709139 16 12.5 16 10.290861 14.209139 8.5 12 8.5zM12 10.5C13.1045695 10.5 14 11.3954305 14 12.5 14 13.6045695 13.1045695 14.5 12 14.5 10.8954305 14.5 10 13.6045695 10 12.5 10 11.3954305 10.8954305 10.5 12 10.5z';
var NavigationIconInspirationActivePath = 'M26.74,9.69 L24.57,24.58 C24.4610931,25.3780387 24.035864,26.0987659 23.39,26.58 C22.8749551,26.961818 22.2511351,27.1685898 21.61,27.17 C21.4635126,27.1802559 21.3164874,27.1802559 21.17,27.17 L19.4,26.91 C21.0105622,26.0288028 22.0086752,24.3358496 22,22.5 L22,6.5 C22.0098654,6.32013518 22.0098654,6.13986482 22,5.96 L24.26,6.29 C25.0580387,6.39890693 25.7787659,6.82413599 26.26,7.47 C26.7109247,8.11582299 26.8838448,8.91557819 26.74,9.69 Z M20,6.5 L20,22.5 C20,24.1568542 18.6568542,25.5 17,25.5 L7,25.5 C5.34314575,25.5 4,24.1568542 4,22.5 L4,6.5 C4,4.84314575 5.34314575,3.5 7,3.5 L17,3.5 C18.6568542,3.5 20,4.84314575 20,6.5 Z M8.5,12.5 C8.5,14.4329966 10.0670034,16 12,16 C13.9329966,16 15.5,14.4329966 15.5,12.5 C15.5,10.5670034 13.9329966,9 12,9 C10.0670034,9 8.5,10.5670034 8.5,12.5 L8.5,12.5 Z M16,18.5 L8,18.5 L8,20.5 L16,20.5 L16,18.5 Z';
var NavigationIcon = baseIcon('NavigationIconInspiration', {
  getPath: _ref => {
    var {
      isActive
    } = _ref;
    return isActive ? NavigationIconInspirationActivePath : NavigationIconInspirationPath;
  },
  styleSheetPropsGetter: (_ref2, designVersion) => {
    var {
      isActive,
      color,
      colorToken,
      colorTokenArgs
    } = _ref2;
    return {
      isActive,
      color,
      designVersion,
      colorToken,
      colorTokenArgs
    };
  },
  defaultStyleSheetGetter: navigationActivatableDefaultStyleSheetGetter,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  restOfPropsSanitizer: _ref3 => {
    var {
        isActive
      } = _ref3,
      restOfProps = _objectWithoutProperties(_ref3, _excluded);
    return restOfProps;
  },
  groupProps: defaultNavigationIconGroupProps,
  shapeSize: defaultNavigationIconShapeSize
});
var NavigationIconInspiration = props => {
  useDeprecationWarning({
    componentName: 'NavigationIconInspiration',
    removalDate: 'v6.0.0'
  });
  return /*#__PURE__*/React.createElement(NavigationIcon, props);
};
NavigationIconInspiration.displayName = 'NavigationIconInspiration';
export default NavigationIconInspiration;
//# sourceMappingURL=index.js.map